<!-- 
    File: cgp-app-card.template.html
    Author: Joseph M Diaz
    Date: 6/6/2018
    Desc: Template for the cgp app card.
    Other Contributors:
-->

<div class="cgp-app-card {{IsShowFooter ? 'footer-height' : ''}}" [ngClass]="{'full-screen': isFullScreen}">
    <div class="cgp-app-card-header" [ngClass]="{'full-screen-enabled': showFullScreenToggle}">
        <span class="back-button" *ngIf="showBackButton" [matTooltip]="backButtonTooltip" [matTooltipShowDelay]="500"
            (click)="onBackButtonClick()">
            <i class="fa fa-chevron-left"></i>
        </span>
        <span class="title">{{titleText}}</span>
        <span class="full-screen-toggle" *ngIf="showFullScreenToggle" [matTooltip]="fullScreenToggleToolTip()"
            [matTooltipShowDelay]="500" (click)="toggleFullScreen()">
            <i class="fa" [ngClass]="{'fa-compress': isFullScreen, 'fa-expand': !isFullScreen}"></i>
        </span>
    </div>
    <div class="cgp-app-card-body {{IsShowFooter ? 'footer-height' : ''}}">
        <ng-content></ng-content>
    </div>
</div>
